// extracted by mini-css-extract-plugin
export default {"link":"KqQ_7N","image":"q8lisa","SloppyPhoto":"lTCs_2","sloppyPhoto":"lTCs_2","wrap":"qqQJKi"};